const route = {
    DASHBOARD: "/dashboard",
    CASHFLOW: "/cashflow",
    KPI: "/kpi",
    TRANSACTIONS: {
        VIEW: "/transactions"
    },
    TRANSACTIONSQUERY: {
        VIEW: "/transaction-queries"
    },
    USERS: {
        VIEW: "/users"
    },
    RENTALS: {
        VIEW: "/rentals"
    },
    HOUSERENTALS: {
        VIEW: "/house-rentals"
    },
    SETTINGS: {
        TENANT: {
            VIEW: "/settings/tenants"
        },
        BUSINESSUNITS: {
            VIEW: "/settings/business-units"
        },
        UNITCODES: {
            VIEW: "/settings/unitcodes"
        },
        TRANSACTIONTYPES: {
            VIEW: "/settings/transaction-types"
        },
        PERMISSIONS: {
            VIEW: "/settings/permissions"
        },
        EXTERNALAPI: {
            VIEW: "/settings/external-api"
        }
    },
    AUDITLOGS: "/auditlogs",
    LOGIN: "/login",
    REGISTER: "/register",
    ERROR403: "/403",
    ERROR404: "/404"
}

export default route
